// import { useState, useEffect } from "react";
// import * as FeatherIcon from "react-feather";

// const ITEMS_PER_PAGE = 10;

// const CompetitorsNew = ({
//   competitorList,
//   onSubmit,
//   updateData,
//   data,
//   showMoreModal,
// }) => {
//   const [selectedCompetitors, setSelectedCompetitors] = useState([]);
//   const [error, setError] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

//   // Reset whenever sidecard opens
//   useEffect(() => {
//     if (showMoreModal) {
//       setSelectedCompetitors([]);
//       setError("");
//       setCurrentPage(1);

//       updateData({
//         selectedCompetitors: [],
//       });
//     }
//   }, [showMoreModal]);

//   const competitorArray = Array.isArray(competitorList)
//     ? competitorList
//     : competitorList?.result || competitorList?.competitors || [];

//   const competitors = competitorArray.map((item) => ({
//     name: item?.competitor || item?.company || item?.name,
//     type: item?.type || "Competitor",
//   }));

//   const totalPages = Math.ceil(competitors.length / ITEMS_PER_PAGE);

//   const paginatedCompetitors = competitors.slice(
//     (currentPage - 1) * ITEMS_PER_PAGE,
//     currentPage * ITEMS_PER_PAGE
//   );

//   useEffect(() => {
//     updateData({
//       selectedCompetitors,
//     });
//   }, [selectedCompetitors]);

//   const toggleCompetitor = (name) => {
//     setError("");

//     setSelectedCompetitors((prev) => {
//       const alreadySelected = prev.includes(name);

//       if (alreadySelected) {
//         return prev.filter((item) => item !== name);
//       }

//       if (prev.length >= 4) {
//         setError("Maximum 4 competitors can be selected");
//         return prev;
//       }

//       return [...prev, name];
//     });
//   };

//   const isSelected = (name) => {
//     return selectedCompetitors.includes(name);
//   };

//   const handleSubmit = () => {
//     if (selectedCompetitors.length < 1) {
//       setError("Please select at least one competitor");
//       return;
//     }

//     onSubmit();
//   };

//   return (
//     <div className="wizard_four">
//       <div className="d-flex justify-content-between align-items-center mb-3 mr-4">
//         <h5 className="ml-4 mt-4 mb-3 custom_lable">Select Competitors</h5>

//         <span
//           style={{
//             fontSize: "13px",
//             color: "#666",
//           }}
//         >
//           {selectedCompetitors.length}/4 Selected
//         </span>
//       </div>

//       {error && (
//         <div className="mt-2 d-flex justify-content-start">
//           <p
//             className="ml-4"
//             style={{
//               color: "red",
//               fontSize: "13px",
//               marginTop: "10px",
//             }}
//           >
//             {error}
//           </p>
//         </div>
//       )}

//       <div className="competitors_block ml-4 mr-4">
//         <div className="row">
//           {paginatedCompetitors.map((comp, idx) => {
//             const selected = isSelected(comp.name);

//             const disableUnchecked =
//               selectedCompetitors.length >= 4 && !selected;

//             return (
//               <div className="col-md-6 mb-3" key={idx}>
//                 <div
//                   className={`comp_block_input ${
//                     selected
//                       ? "comp_block_input_click"
//                       : "comp_block_input_unclick"
//                   } ${disableUnchecked ? "opacity-50" : ""}`}
//                   onClick={() => {
//                     if (!disableUnchecked) {
//                       toggleCompetitor(comp.name);
//                     }
//                   }}
//                   style={{
//                     cursor: disableUnchecked ? "not-allowed" : "pointer",
//                     pointerEvents: disableUnchecked ? "none" : "auto",
//                   }}
//                 >
//                   <div className="form-check">
//                     <input
//                       type="checkbox"
//                       className="form-check-input me-2"
//                       checked={selected}
//                       disabled={disableUnchecked}
//                       readOnly
//                     />
//                   </div>

//                   <div className="direct_comp_lable_block">
//                     <label className="form-check-label fw-semibold">
//                       {comp.name}
//                     </label>

//                     <p className="direct_comp_lable">{comp.type}</p>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {totalPages > 1 && (
//         <div className="d-flex justify-content-end align-items-center mt-3 mr-4 gap-2">
//           <button
//             className="btn btn-sm btn-light"
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage((prev) => prev - 1)}
//           >
//             <FeatherIcon.ChevronLeft size={16} />
//           </button>

//           <span
//             style={{
//               fontSize: "13px",
//               fontWeight: 500,
//             }}
//           >
//             Page {currentPage} of {totalPages}
//           </span>

//           <button
//             className="btn btn-sm btn-light"
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage((prev) => prev + 1)}
//           >
//             <FeatherIcon.ChevronRight size={16} />
//           </button>
//         </div>
//       )}

//       <div className="ml-4 mt-4 mr-4 d-flex justify-content-end">
//         <button className="btn btn-primary next_btn_wz" onClick={handleSubmit}>
//           Create Benchmark
//           <FeatherIcon.ChevronRight className="next_feather" />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CompetitorsNew;

import { useState, useEffect } from "react";
import * as FeatherIcon from "react-feather";
import Alert from "../../../HtmlElements/Alert";
import { useSelector } from "react-redux";

const ITEMS_PER_PAGE = 10;

const CompetitorsNew = ({
  competitorList,
  onSubmit,
  updateData,
  data,
  defaultSelectedCompetitors,
  showMoreModal,
  setShowMoreModal,
  clientName,
}) => {
  const [selectedCompetitors, setSelectedCompetitors] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showAlert, setShowAlert] = useState(false);

  const {
    data: createBenchmarkResponse,
    loading: createBenchmarkLoading,
    error: createBenchmarkError,
  } = useSelector((state) => state.createBenchmarkReducer);

  const getAlertType = () => {
    const status = createBenchmarkResponse?.status;

    if (status === "submitted") {
      return "success";
    }

    if (status === "already_exists" || status === "processing") {
      return "danger";
    }

    return "success";
  };

  const getMessage = () => {
    const status = createBenchmarkResponse?.status;

    if (status === "submitted") {
      return `Benchmarking for ${clientName} & its competitors is in progress.`;
    }

    if (status === "already_exists" || status === "processing") {
      return `Benchmarking already in progress for ${clientName}.`;
    }

    return "";
  };

  useEffect(() => {
    if (createBenchmarkResponse?.message) {
      setShowAlert(true);
    }
  }, [createBenchmarkResponse]);

  useEffect(() => {
    if (!showMoreModal) {
      setShowAlert(false);
    }
  }, [showMoreModal]);

  // Reset whenever sidecard opens
  // useEffect(() => {
  //   if (showMoreModal) {
  //     setSelectedCompetitors([]);
  //     setError("");
  //     setCurrentPage(1);

  //     updateData({
  //       selectedCompetitors: [],
  //     });
  //   }
  // }, [showMoreModal]);

  useEffect(() => {
    if (showMoreModal) {
      setSelectedCompetitors(defaultSelectedCompetitors || []);

      setError("");
      setCurrentPage(1);

      updateData({
        selectedCompetitors: defaultSelectedCompetitors || [],
      });
    }
  }, [showMoreModal, defaultSelectedCompetitors]);

  useEffect(() => {
    if (
      createBenchmarkResponse?.status === "submitted" ||
      createBenchmarkResponse?.status === "already_exists" ||
      createBenchmarkResponse?.status === "processing"
    ) {
      const timer = setTimeout(() => {
        setShowMoreModal(false);
      }, 7000);

      return () => clearTimeout(timer);
    }
  }, [createBenchmarkResponse]);

  const competitorArray = Array.isArray(competitorList)
    ? competitorList
    : competitorList?.result || competitorList?.competitors || [];

  // const competitors = competitorArray.map((item) => ({
  //   name: item?.competitor || item?.company || item?.name,
  //   type: item?.type || "Competitor",
  // }));

  const competitors = competitorArray.map((item) => ({
    name: item?.competitor || item?.company || item?.name,
    type: item?.type || "Competitor",
  }));

  // Move selected competitors to top
  const sortedCompetitors = [
    ...competitors.filter((comp) => selectedCompetitors.includes(comp.name)),
    ...competitors.filter((comp) => !selectedCompetitors.includes(comp.name)),
  ];

  // const totalPages = Math.ceil(competitors.length / ITEMS_PER_PAGE);

  // const paginatedCompetitors = competitors.slice(
  //   (currentPage - 1) * ITEMS_PER_PAGE,
  //   currentPage * ITEMS_PER_PAGE
  // );

  const totalPages = Math.ceil(sortedCompetitors.length / ITEMS_PER_PAGE);

  const paginatedCompetitors = sortedCompetitors.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  useEffect(() => {
    updateData({
      selectedCompetitors,
    });
  }, [selectedCompetitors]);

  const toggleCompetitor = (name) => {
    setError("");

    setSelectedCompetitors((prev) => {
      const alreadySelected = prev.includes(name);

      if (alreadySelected) {
        // return prev.filter((item) => item !== name);
        // setCurrentPage(1);
        return prev.filter((item) => item !== name);
      }

      if (prev.length >= 4) {
        setError("Maximum 4 competitors can be selected");
        return prev;
      }

      // return [...prev, name];
      // setCurrentPage(1);
      return [...prev, name];
    });
  };

  const isSelected = (name) => {
    return selectedCompetitors.includes(name);
  };

  const handleSubmit = () => {
    if (selectedCompetitors.length < 2) {
      setError(
        `Please select at least ${
          competitors?.length > 2 ? "two" : "one"
        } competitor`
      );
      return;
    }

    onSubmit();
  };

  return (
    <div className="wizard_four">
      <div className="d-flex justify-content-between align-items-center mb-3 mr-4">
        <h5 className="ml-4 mt-4 mb-3 custom_lable">Select Competitors</h5>

        <span
          style={{
            fontSize: "13px",
            color: "#666",
          }}
        >
          {selectedCompetitors.length}/4 Selected
        </span>
      </div>

      {/* {createBenchmarkResponse?.message && ( */}
      {showAlert && createBenchmarkResponse?.message && (
        <div className="ml-4 mr-4 mb-3">
          <Alert
            type={getAlertType()}
            // message={createBenchmarkResponse?.message}
            message={getMessage()}
          />
        </div>
      )}

      {error && (
        <div className="mt-2 d-flex justify-content-start">
          <p
            className="ml-4"
            style={{
              color: "red",
              fontSize: "13px",
              marginTop: "10px",
            }}
          >
            {error}
          </p>
        </div>
      )}

      <div className="competitors_block ml-4 mr-4">
        <div className="row">
          {paginatedCompetitors.map((comp, idx) => {
            const selected = isSelected(comp.name);

            const disableUnchecked =
              selectedCompetitors.length >= 4 && !selected;

            return (
              <div className="col-md-6 mb-3" key={idx}>
                <div
                  className={`comp_block_input ${
                    selected
                      ? "comp_block_input_click"
                      : "comp_block_input_unclick"
                  } ${disableUnchecked ? "opacity-50" : ""}`}
                  onClick={() => {
                    if (!disableUnchecked) {
                      toggleCompetitor(comp.name);
                    }
                  }}
                  style={{
                    cursor: disableUnchecked ? "not-allowed" : "pointer",
                    pointerEvents: disableUnchecked ? "none" : "auto",
                  }}
                >
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                      checked={selected}
                      disabled={disableUnchecked}
                      readOnly
                    />
                  </div>

                  <div className="direct_comp_lable_block">
                    <label className="form-check-label fw-semibold">
                      {comp.name}
                    </label>

                    <p className="direct_comp_lable">{comp.type}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {totalPages > 1 && (
        <div className="d-flex justify-content-end align-items-center mt-3 mr-4 gap-2">
          <button
            className="btn btn-sm btn-light"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            <FeatherIcon.ChevronLeft size={16} />
          </button>

          <span
            style={{
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="btn btn-sm btn-light"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            <FeatherIcon.ChevronRight size={16} />
          </button>
        </div>
      )}

      <div className="ml-4 mt-4 mr-4 d-flex justify-content-end">
        {/* <button className="btn btn-primary next_btn_wz" onClick={handleSubmit}> */}
        <button
          className="btn btn-primary next_btn_wz"
          onClick={handleSubmit}
          disabled={createBenchmarkLoading}
        >
          {createBenchmarkLoading ? "Creating..." : "Create Benchmark"}
          <FeatherIcon.ChevronRight className="next_feather" />
        </button>
      </div>
    </div>
  );
};

export default CompetitorsNew;
